import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function LoanTable(data) {




    useEffect(()=>{
            
    },[])
  return (

    <section
      className="services-area bg-white pb-120 wow fadeInUp"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <div className="container">
        <div className="section-title  ">
            <h3 className='pb-20 pt-10'>{data.data.tableHeading}</h3>
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead style={{minWidth:"100%",}}>
                <tr style={{ backgroundColor: "whitesmoke"}}>
                                    <th className="text-center" scope="col"  style={{minWidth:"50px",maxWidth:"50px"}}>
                      <h5 style={{ fontSize: "80%" }}>{"Bank".toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"  style={{minWidth:"300px"}} >
                      <h5 style={{ fontSize: "80%" }}>{"Intrest rate".toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"   style={{minWidth:"300px"}}>
                      <h5 style={{ fontSize: "80%" }}>{"Tenure".toUpperCase()}</h5>
                    </th>
                    <th className="text-center" scope="col"  style={{minWidth:"300px"}} >
                      <h5 style={{ fontSize: "80%",minWidth:"100%" }}>{"Loan Amount".toUpperCase()}</h5>
                    </th>
                
                </tr>
              </thead>
              <tbody>
                {data?.data?.tableData.map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal" }}
                        
                      >
                        <Link  to={"/bankInnerPage"} state={item} >
                       <img  style={{width:"45px"}} src={item.bankImage} alt={item.bankName} /> 
                       </Link>
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal" }}
                        
                      >
                      {item.interestRate} 
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal" }}
                        
                      >
                      {item.tenure} 
                      </td>
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal" }}
                        
                      >
                      {item.loanAmount} 
                      </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}


